// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import theme from 'config/theme'
import { createRouter } from 'router/index'
import { createStore } from 'store/index'
import { sync } from 'vuex-router-sync'
import {
  Vuetify,
  VApp,
  VCard,
  VForm,
  VTextField,
  VCheckbox,
  VNavigationDrawer,
  VFooter,
  VBadge,
  VList,
  VBtn,
  VSwitch,
  VIcon,
  VGrid,
  VToolbar,
  VSnackbar,
  VExpansionPanel,
  VDialog,
  VSubheader,
  VDivider,
  VDataTable,
  VTooltip,
  VAvatar,
  VBtnToggle,
  transitions,
  VRadioGroup,
  VCarousel,
  VSlider,
  VMenu,
  VTabs,
  VSpeedDial,
  VSelect,
  VChip,
  VStepper,
  VAlert,
  VDatePicker,
  VTimePicker,
  VProgressCircular,
  VBottomSheet
} from 'vuetify'
import '../node_modules/vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  components: {
    VApp,
    VCard,
    VForm,
    VTextField,
    VCheckbox,
    VNavigationDrawer,
    VFooter,
    VBadge,
    VList,
    VBtn,
    VSwitch,
    VIcon,
    VGrid,
    VToolbar,
    VSnackbar,
    VExpansionPanel,
    VDialog,
    VSubheader,
    VDivider,
    VDataTable,
    VTooltip,
    VAvatar,
    VBtnToggle,
    transitions,
    VRadioGroup,
    VCarousel,
    VSlider,
    VMenu,
    VTabs,
    VSpeedDial,
    VSelect,
    VChip,
    VStepper,
    VAlert,
    VDatePicker,
    VTimePicker,
    VProgressCircular,
    VBottomSheet
  }
})

import VueAWN from "vue-awesome-notifications"
let options = {
  position: 'top-right',
  duration: 4000,
  labels: {
    info: 'Info',
    success: 'Éxito',
    tip: 'Tip',
    warning: 'Atención',
    alert: 'Error'
  }
}
Vue.use(VueAWN, options)
require("vue-awesome-notifications/dist/styles/style.css")



export function createApp () {
  const store = createStore()
  const router = createRouter(store)

  sync(store, router)

  // store.dispatch('api/initApp')

  Vue.config.productionTip = false

  /* eslint-disable no-new */
  const app = new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
  })

  return { app, router, store }
}



// WEBPACK FOOTER //
// ./src/app.js